import { Component, OnInit } from "@angular/core";
import { locale as italian } from "../../../../i18n/it";
import { CitiesService } from "../../../../auth/service/cities.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-cities-list",
  templateUrl: "./cities-list.component.html",
  styleUrls: ["./cities-list.component.scss"],
})
export class CitiesListComponent implements OnInit {
  public contentHeader: IContentHeader;
  public filteredCities: any;
  public tableLimit: number = 10;
  public searchKeyword: string = "";

  constructor(
    public _citiesService: CitiesService,
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.MENU.CITIES,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.MENU.CITIES,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    await this.loadCities();
  }

  async loadCities() {
    this.doFilter();
    this._utilService.hideLoading();
  }

  async remove(event: any, city_id: number) {
    event.preventDefault();
    await this._utilService
      .showSWAL({
        title: "CONFIRM_DELETE_TITLE",
        text: "CONFIRM_DELETE_TEXT",
        icon: "warning",
        confirmButtonText: "CONFIRM_DELETE_BTN",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      })
      .then(async (result: any) => {
        if (result.value) {
          if (!this._authenticationService.hasCapability("city_delete")) {
            window.history.back();
            return false;
          }
          await this._citiesService.delete(city_id).then(async () => {
            await this._utilService.showPopupItemDeleted().then(async () => {
              await this.loadCities();
            });
          });
        } else if (result.isDismissed) {
          await this._utilService.showSWAL({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
            icon: "error",
            confirmButtonText: "BTN_CLOSE",
            showCancelButton: false,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }

  doFilter() {
    if (this._citiesService.list.length < 1) {
      return setTimeout(() => this.doFilter());
    }

    let filtered: any = this._citiesService.list;

    if (this.searchKeyword.length > 0) {
      const keyword: string = this.searchKeyword.toLowerCase();
      filtered = filtered.filter((cap: any) => cap.name.toLowerCase().includes(keyword));
    }

    this.filteredCities = filtered;
  }
}
